class Layout
  phone_ratio : 16 / 8.8
  button_ratio : 1 / 4
  logos_ratio : 1 / 7
  todo_ratio : 1 / 12
  max_page_width : 600
  bezel : 
    top : 1 / 30
    side : 1 / 28
    bottom : 1 / 12
  user_muted : false
  constructor : (mobile, winners) ->
    @w = window.innerWidth
    @h = window.innerHeight
    set_default_page = () =>
      @page = 
        x : 0
        y : 0
        w : @w - @phone.w
        h : @h

    if mobile
      @phone = 
        x : 0
        y : 0
        w : @w
        h : @h
      set_default_page()
    else
      if @h > @w
        @phone = 
          x : @w * 0.5 - 0.5 * (@h / @phone_ratio)
          y : 0
          w : @h / @phone_ratio
          h : @h
        set_default_page()

      else
        fat_w = @max_page_width + 200 + (@h / @phone_ratio)
        if @w > fat_w and not winners
          @phone = 
            x : @w - 200 - (@h / @phone_ratio)
            y : 0
            w : @h / @phone_ratio
            h : @h

          @page = 
            x : 0
            y : 0
            w : @phone.x
            h : @h
        else
          @phone = 
            x : @w - (@h / @phone_ratio)
            y : 0
            w : @h / @phone_ratio
            h : @h
          set_default_page()

    @screen = 
      x : @bezel.side * @phone.w + @phone.x
      y : @bezel.top * @phone.h
      w : @phone.w - (@bezel.side * @phone.w) * 2
      h : @phone.h - ((@bezel.top + @bezel.bottom) * @phone.h)

    button_width = @phone.w * @button_ratio
    @home_button = 
      x : @phone.x + @phone.w * 0.5 - button_width * 0.5
      y : @phone.h - (@bezel.bottom * 0.85) * @phone.h
      w : button_width
      h : @phone.h * @bezel.bottom * 0.7

    @left_button = 
      x : @phone.x + (@phone.w / 3) - button_width
      y : @phone.h - (@bezel.bottom * 0.85) * @phone.h
      w : button_width
      h : @home_button.h

    @right_button = 
      x : @phone.x + (@phone.w / 3) * 2
      y : @phone.h - (@bezel.bottom * 0.85) * @phone.h
      w : button_width
      h : @home_button.h

    @display = 
      x : 0
      y : 0
      w : @screen.w
      h : @screen.h - @screen.h * @logos_ratio

    @status_height = @display.h * @todo_ratio

    @todo_closed = - @display.h + @status_height

    @logos = 
      x : 0
      y : @screen.h - @screen.h * @logos_ratio
      w : @screen.w
      h : @screen.h * @logos_ratio

class LogoBar
  constructor : (@logos, @w, @h) ->
    @current = 0
    @images = @logos.map((l) => @create_image(l))
    @view()
  create_image : (logo, side) ->
    $("<img>",
      class : "logo_image"
      src : "#{logo.base_dir}/#{logo.name}"
    )
  next : () ->
    (@current + 1) % @images.length
  view_bar : () -> 
    [0..VisibleLogos - 1].map((i) => 
      @images[wrap(@current + i, @images)]
    )
  view : () -> 
    $(".logo_image").css(width : "#{(95 / VisibleLogos)}%")
    $("#logos").html @view_bar()
  step : () -> @current = (@current + 1) % @logos.length
  update : () ->
    @step()
    @view()


class Domer
  language : "hun"

  menu_button : (p, i, array) ->
    capitalize = (t) -> 
      t[0].toUpperCase() + t.substring(1)
    h = (@layout.display.h / array.length)
    
    $("<button>", {
      class : "menu_item"
      css : 
        top : 0
        height : h
      html : [
        $("<img>", 
          class : "menu_image"
          css : 
            marginTop : -h * 0.25;
            left : h * 0.2
          src : "assets/images/#{p.id}.svg")
        $("<div>"
          html : capitalize(p.title)
          class : "menu_text"
          css : 
            top : "50%"
            marginLeft : h * 0.75
            # marginTop : 
        )
      ]
      id : p.id 
      click : (e) => 
        id = e.currentTarget.id
        @navigate id

        if @playing or @is_mobile()
          @toggle_menu !@menu_active

        $(e.currentTarget).blur()
      }
    )
  create_menu : () ->
    $("#menu").html( Pages.map @menu_button.bind(@) )
    
  
  menu_active : true
  playing : false
  play_sign : "play_stroke"
  menu_sign : "menu"
  close_sign : "close" # "&#215;"
  get_menu_sign : () ->
    $("<img>", 
      src : "assets/images/" + (
        if @menu_active
          if @is_mobile() then @close_sign else @play_sign
        else 
          @menu_sign
      ) + ".svg"
    )
  toggle_menu : (a) ->
    @start_playing()

    @menu_active = a
    css = 
      if a
        top : 0
        opacity : 1
        left : 0
        width : "100%"
      else
        top : "100%"
        opacity : 0
        left : "50%"
        width : 0
    $("#menu").css(css)
    $("#home_button").html @get_menu_sign()

    @toggle_todo false


  clock_timer : null
  clock_seconds : 0
  zero_pad : (n) ->
    if n < 10 then "0#{n}" else "#{n}"

  print_clock : (s) ->
    mins = Math.floor(s / 60)
    seconds = s % 60
    "#{@zero_pad(mins)}:#{@zero_pad(seconds)}".replace(/0/g, "O")
  won : false
  step_clock : () ->
    if not @won
      @clock_seconds = (@clock_seconds + 1) % 1440
      $("#clock").html(@print_clock(@clock_seconds))
      if @clock_seconds % 2 == 0
        @logos.update()
  start_playing : () ->
    if not @playing
      @playing = true
      # @update_mute false
      @step_clock()
      @clock_timer = window.setInterval @step_clock.bind(@), 1000
  home_click : (e) ->
    if e isnt "system"
      $("#home_button")
        .removeClass("ringing")
        .blur()
      if @is_mobile()
        if @todo_visible
          @toggle_todo()
      else if Toner?
        Toner.set_mute(false)
      @update_mute false
    @toggle_menu(!@menu_active)


  is_mobile : () ->
    isMobile.any or window.innerWidth < window.innerHeight

  # toggle_mute : (e) ->
    # muted = Toner.toggle_mute()
    # @update_mute muted

  user_click_mute : (e) ->
    if Toner?
      if e.stopPropagation
        e.stopPropagation()
      @update_mute Toner.click_mute()

  update_mute : (m) ->
    v = $("#volume")
    if m and not v.hasClass "muted"
      v.attr("src", "assets/images/volume_off.svg").addClass "muted"
    else if v.hasClass "muted"
      v.attr("src", "assets/images/volume_up.svg").removeClass "muted"
  navigate : (id) ->
    window.location.hash = "##{id}"
  english : false
  toggle_lang : (e) ->
    if e.stopPropagation
      e.stopPropagation()

    @english = !@english
    $("#lang").html(if @english then "HUN" else "ENG")

    if @is_mobile()
      @open_page "nyertesek", true
    else
      if @current_winner isnt -1
        @load_winner_todo @current_winner
      WinnersMaze.toggle_lang @english


  constructor : (@main) ->
    @generate_layout()
    @iframe = $("<iframe>", class : "iframe").attr("scrolling", "no").get(0)
      # ...
    
    $("#lang").click @toggle_lang.bind(@)

    $("#home_button")
      .click(@home_click.bind(@))
      .html @get_menu_sign()
    $("#inner .simplebar-content").html @iframe
    @resize()

    @logos = new LogoBar( Logos, @layout.logos.w, @layout.logos.h)
    if @is_mobile()
      $("#page").appendTo($("#screen"))
      # @navigate StartPage
      @toggle_menu false

      $("#todo").click((e) => @toggle_todo())
    else
      $("#todo").click((e) => @toggle_todo())


      $("#volume").click(@user_click_mute.bind @)

      @update_mute true


      $("#wifi").click((e) -> 
        e.stopPropagation()
        $(@).css("filter", "brightness(-50%)")
        window.location.reload())

    $("#left_button").click((e) => @step_winners -1)
    $("#right_button").click((e) => @step_winners 1)
    $(window).keydown((e) => 
      if e.key is "ArrowLeft"
        @step_winners -1
      else if e.key is "ArrowRight"
        @step_winners 1
    )
    


    # @start_playing()



  resize_iframe : () ->
    $("iframe").css  height : 0
    doc = @iframe.contentWindow.document
    body = doc.body
    html = doc.documentElement
    h = Math.max( 
      body.scrollHeight, body.offsetHeight,
      html.clientHeight, html.scrollHeight, html.offsetHeight )
    # h = @iframe.contentDocument.getElementsByClassName("pages")[0].scrollHeight
    h = height : "#{h + (if isMobile.any then 200 else 200)}px"
    $("iframe").css  h
    $("#inner .simplebar-content-wrapper").css  h 


  set_rect : (selector, box) ->
    $(selector).css(
      left : box.x
      top : box.y
      width : box.w
      height : box.h
    )
  generate_layout : () ->
    @layout = new Layout @is_mobile(), (@current? and @current.id is "nyertesek") or window.location.hash.substring(1) is "nyertesek"

  todo_visible : false

  load_winner_todo : (winner_id) ->
    @current_winner = winner_id
    $(".simplebar-content-wrapper").scrollTop 0  
    w = if @english then _Winners[winner_id] else _Nyertesek[winner_id]
    $("#todo_title").hide()
    $("#todo_list").html([
      $("<div>"
        html : w.name.join(", ")
        class : "winner-name"
        css : 
          whiteSpace : "pre-wrap"
      ),
      $("<div>"
        html : w.title
        class : "winner-title"
        css : 
          whiteSpace : "pre-wrap"
      ),
      $("<div>"
        html : w.text
        class : "winner-text"
        css : 
          whiteSpace : "pre-wrap"
      )
    ])
  create_mobile_todos : () ->
    capitalize = (t) -> 
      t[0].toUpperCase() + t.substring(1)
    c = "#FFC642"
    $("#todo_title").html("mit keresel?").css(backgroundColor : c)
    $("#todo_list").html($("<div>"
      html : "ha játszanál egyet, látogass el hozzánk asztali gépről!"
      class : "todo_item"
    ))
  show_ending : () ->
    Computer.booton()
    if Toner?
      Toner.maze.stop()
    $("#todo_title").html("Kijutottál!").css(backgroundColor : Colors.yellow)
    $("#todo_list").append($("<div>"
      html : "köszönjük, hogy játszottál!"
      class : "todo_item"
    ))
    $("#todo_container").css(backgroundColor : Colors.yellow)
    $("#todo_list").append($("<div>"
      html : "futás idő : #{@print_clock(@clock_seconds)}"
      class : "todo_item"
      css : 
        textAlign : "right"
    ))

  create_todos : () ->

    todos = Object.keys(TODO).map((k, i) -> {id : k, text : TODO[k].text, enabled : TODO[k].enabled})
    capitalize = (t) -> 
      t[0].toUpperCase() + t.substring(1)
    
    h = - @layout.todo_closed / todos.length

    todo_item = (p, i) =>
      $("<div>",
        class : "todo_item"
        html : (if p.enabled then "# " else "- ") + p.text
        id : p.id
        css : 
          fontSize : @layout.display.w * (1/ 18)
      ).addClass(
        if p.enabled then "checked" else undefined
      )
    $("#todo_title").html("Tennivalók")
    $("#todo_list").html(
      todos.map(todo_item)
    )
    @won = WON()
    if @won
      @show_ending()

  toggle_todo : (active, winner_id) ->
    if active?
      @todo_visible = active
    else
      @todo_visible = !@todo_visible

    if @todo_visible
      $("#todo").css(
        top : 0
      )
      if winner_id?
        @load_winner_todo winner_id
      else if @is_mobile()
        @create_mobile_todos()
      else if @current.id isnt "nyertesek"
        $("#todo_title").show()
        @create_todos()
      $("#check_title").css("display", "inline-block")
      $("#check").css("display", "none")
    else
      $("#check_title").css("display", "none")
      $("#check").css("display", "block")
      $("#todo").css(
        top : @layout.todo_closed
      )

  mobile_mod : () ->
    $(".menu_item").css(backgroundColor : "#eee6")
    $("#menu").css(backgroundImage: 'url("assets/images/blurred_render.png ")')
    $("#page").css(
      zIndex : 1
    )
    $("#inner .simplebar-content-wrapper").css(
      paddingTop : @layout.status_height
    )


  resize : () ->
    @generate_layout()
    @set_rect("#phone", @layout.phone)
    @set_rect("#screen", @layout.screen)
    @set_rect("#home_button", @layout.home_button)

    @set_rect("#left_button", @layout.left_button)
    @set_rect("#right_button", @layout.right_button)

    $("#home_button").css("font-size", $("#home_button").height() * 0.65)
    @set_rect("#logos", @layout.logos)
    @set_rect("#menu", @layout.display)
    @toggle_menu @menu_active
    @set_rect("#display", @layout.display)

    @set_rect("#todo", {
      x : @layout.display.x
      y : @layout.todo_closed
      w : @layout.display.w
      h : @layout.display.h
    })

    @set_rect("#todo_container", {
      x : 0
      y : 0
      h : @layout.display.h - @layout.status_height
      w : @layout.display.w# - @layout.status_height
    })

    @set_rect("#status", {
      w : @layout.display.w
      h : @layout.status_height
    })

    @set_rect(".noticon", {
      w : "auto"
      h : @layout.status_height * 0.8
      y : @layout.status_height * 0.1
    })
    h = @layout.status_height * 0.7
    $("#lang").css {
      "font-size" : h
      "margin-top" : -h * 0.125
      right : @layout.status_height * 4
    }

    c = Pages.length
    h = @layout.display.h / c
    $(".menu_item").css(
      height : @layout.display.h / c
      "font-size" : h / 3
    )

    if @is_mobile()
      $("#page").appendTo("#screen").css(
        position : "absolute"
        width : "100%"
        height : @layout.display.h
        left : 0
        top : 0
      )
      if @current? && @current.id is "nyertesek"
        $("#winners_maze").hide()
        @open_winner_page @current_winner, null, true

    else
      @set_rect("#page", @layout.page)
      $("#page").appendTo($("body"))

      if @current? && @current.id is "nyertesek"
        $("#winners_maze").show()

    @create_menu()

    $("#check").css(
      left : @layout.status_height * 1.1
    )

    $("#clock").css(
      fontSize : @layout.status_height * 0.6
    )
    $("#todo_title").css
      fontSize : @layout.status_height * 0.6

    if @is_mobile()
      @mobile_mod()

  active : (n) ->
    @current? and @current.id is n

  # open_url : (url, menu) ->
  #   if menu? or not @current?
  #     @f (if menu? then menu else "nevezes"), false, url
  #   else
  #     $(@iframe).attr("src", url)
  #     $("#inner .simplebar-content-wrapper").scrollTop 0  
  #     $("iframe").css height : 0 
  #     @iframe.onload = (() =>
  #       @resize_iframe()
  #     )

  select_menu : (id) ->

    i = Pages.findIndex((page) -> page.id is id)
    $(".menu_item").removeClass("selected_menu")
    $(".menu_item").eq(i).addClass("selected_menu")

  bind_iframe_events : () ->
    keydown = (e) -> Keys.press e
    keyup = (e) -> Keys.release e
    mousedown = (e) -> Mouse.down e
    mouseup = (e) -> Mouse.up e
    $(@iframe.contentWindow.document)
      .keydown(keydown)
      .keyup(keyup)
  load_contents_to_page : (c) ->
    $("#inner .simplebar-content").html c

  open_page : (n, force = false) ->
    cp = Pages.find((p) -> p.id is n)
    if not force and @current? and cp.id is @current.id
      return

    @select_menu n
    @current = cp

    $(@iframe).attr("src", @current.source)
    $("#inner .simplebar-content-wrapper").scrollTop 0  
    $("#inner .simplebar-content").html @iframe
    if @iframe
      $("iframe").css height : 0 
      @iframe.onload = () =>
        @toggle_menu false
        @resize_iframe()


        @toggle_winners(n is "nyertesek")

        if not @is_mobile()
          DomItems.add @current.id
          @bind_iframe_events()
        # if @current_winner is -1 then @current_winner = 0
  
  current_winner : -1

  toggle_winners : (enter) ->
    if enter
      $("#left_button, #right_button, #lang").show()
      if not @is_mobile()
        # Main.world.renderer.gammaOutput = false
        # Main.world.renderer.gammaFactor = 0
        WinnersMaze.open()
      else
        if @current_winner is -1
          @current_winner = 0
        @open_winner_page @current_winner, (() ->), true
    else
      $("#left_button, #right_button, #lang").hide()
      if not @is_mobile()
        # Main.world.renderer.gammaFactor = 1.5
        # Main.world.renderer.gammaOutput = true
        WinnersMaze.close()

  open_winner_page : (i, callback, force = false) ->
    if not force and @current_winner is i
      return

    @current_winner = i

    if @is_mobile()
      w = 
        if @english
          _w = _Winners[i]
          _w.video_link = _Nyertesek[i].video_link
          _w
        else 
          _Nyertesek[i]

      d = @iframe.contentWindow.document
      $(d).find("#winner-names").html w.name.join(", ")
      $(d).find("#winner-text").html w.text
      $(d).find("#winner-title").html w.title
      $(d).find("#winner-video").show().attr "src", w.video_link
      $("#inner .simplebar-content-wrapper").scrollTop 0  
      @resize_iframe()
    else
      if callback? then callback d, @current_winner, force

  step_winners : (d) ->
    nt = 
      if @current_winner is -1
        if d is -1 then _Nyertesek.length - 1 else 0 
      else wrap(@current_winner + d, _Nyertesek)
    @toggle_todo false
    if @is_mobile()
      Main.set_winner_url nt
    else
      @open_winner_page nt, (p) => WinnersMaze.open_winner(p, nt)